import React, { useContext, useEffect } from 'react';
import { Button } from 'antd';
import { LoansViewContext } from 'scenes/Private/Private';
import { useIsImpersonating } from 'components/Atoms/Bars/ProcessingTeamImpersonationBar/ProcessingTeamImpersonationBar';

interface Props {
  visible: boolean;
  handlerSetVisibile: Function;
  children?: React.ReactElement;
  elementAbsolute?: React.ReactElement;
}

const RightScenes = (props: Props) => {
  const { lockedDeadLayout }: any = useContext(LoansViewContext);

  useEffect(() => {
    document.body.style.overflowY = (props.visible)? "hidden" : "scroll";
  }, [props.visible])

  const closeModal = () => {
    document.body.style.overflowY = "scroll";
    props.handlerSetVisibile(false);
  }
  
  if(!props.visible) return null;

  const { showProcessingBar }  = useIsImpersonating();

  return props.visible && (
    <div className="right-scenes" style={{ top: showProcessingBar ? '100px' : '50px' }}>
      <div className={`right-scenes-content`} style={{ width: lockedDeadLayout ? '100%' : '80%' }}>
      {props.elementAbsolute}
        <div className="content-modal">
          <div className="modal-container">
            <div className="modal-cards modal-cards--full">
              <div className="modal-cards-mx-w">
                <div className="flex-btw">
                </div>
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Button
        className="button-close-mask"
        style={{ width: '20%', marginLeft: 10, display: lockedDeadLayout ? 'none' : 'block' }}
        onClick={closeModal}
      />

    </div>

  );
};
export default RightScenes;
